import { useEffect, useRef } from 'react';
/**
 * Attaches an event listener to the window object for the specified event.
 */

export default function useWindowEvent(eventName, handler) {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);
  useEffect(() => {
    const wrappedHandler = event => handlerRef.current(event);

    window.addEventListener(eventName, wrappedHandler);
    return () => window.removeEventListener(eventName, wrappedHandler);
  }, [eventName]);
}